<template>
<a-space direction="vertical" :class="endStationIndex ? 'verActive' : ''">
    <div class="address-choose">
        <a-button v-if="!disabled" type="link" @click="handleSelect">
            <img class="addressIcon" src="@/assets/img/address.png">从地址库选择
        </a-button>
    </div>
    <div class="tableBox">
        <a-row >
            <a-col :md="8" :sm="24">
            <a-form-model-item
                label="站点名称"
                :colon="false"
            >
                <a-input v-model="endStation.stationName" placeholder="请输入"></a-input>
            </a-form-model-item>
        </a-col>
            <a-col :md="8" :sm="24">
                <FormItemName
                    v-model.trim="endStation.contactName"
                    :prop-prefix="propPrefix"
                    :disabled="disabled"
                />
            </a-col>
            <a-col :md="8" :sm="24">
                <FormItemPhone
                    v-model="endStation.contactPhone"
                    :prop-prefix="propPrefix"
                    :disabled="disabled"
                />
            </a-col>
            <a-col :md="8" :sm="24">
                <a-form-model-item
                    label="期望送达时间"
                    :colon="false"
                    :prop='`${propPrefix}.expectTime`'
                    :rules="[
                        { required: true, message: '请选择需要送达时间', trigger: 'change' },
                    ]"
                >
                    <a-date-picker
                    v-model="endStation.expectTime"
                    :disabled-date="disabledDate"
                    :disabled-time="disabledDateTime"
                    :show-time="{ defaultValue: defaultTime }"
                    placeholder="请选择"
                    @change="handleChange"
                    @focus="handleFocus" />
                </a-form-model-item>
            </a-col>
            <a-col :md="16" :sm="24">
                <!-- <FormItemAddress
                    :address="endStation"
                    :prop-prefix="propPrefix"
                    :disabled="disabled"
                    @change="handleAdressChange" /> -->
                <a-form-model-item
                    label="联系人地址"
                    :colon="false"
                    :label-col="{span: 3}"
                    :wrapper-col="{span: 21}"
                    :rules="addressRules"
                    :prop="`${propPrefix}.address`"
                >
                    <address-detil 
                    :default-address="defaultAddress"
                    :default-suffix="defaultSuffix"
                    :disabled="disabled"
                    @updateData="handleAdressChange"
                    @removeData="removeData"></address-detil>
                </a-form-model-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
                <a-form-model-item
                    label="外部订单号"
                >
                    <a-input v-model="endStation.crmNumber" class="orderNumStyle" placeholder="每个目的地填写不同的外部订单号，此单号必须唯一" />
                </a-form-model-item>
            </a-col> -->
            <a-col v-if="filteryugu()" :md="6" :sm="24">
                <a-form-model-item
                    label="预估里程"
                    :colon="false"
                >
                    <a-input-number v-model="endStation.mileageKm" suffix="KM" class="orderNumStyle" :max="5000" :min="0" :formatter="limitDecimals" :parser="limitDecimals" placeholder="请输入预估里程" />
                </a-form-model-item>
            </a-col>
        </a-row>
        <slot></slot>
    </div>
    <SelectAddressDialog ref="SelectAddressDialog" :station-type="StationTypes.RECEIVING" :is-standard='true' @onSelectAddress="handleAdressFromSelectorChange"/>
 </a-space>
</template>
<script>
import moment from 'moment';
import FormValidator from '@/constants/formValidator'
import { mapState } from 'vuex'
import {TIME_UNIT,TIME_UNIT_MAP,range} from '@/constants/ruleConfig'
import SelectAddressDialog from '../../components/SelectAddressDialog'
import { StationTypes } from '../../constant';

import {
    FormItemName,
    FormItemPhone,
    // FormItemAddress
} from '../../components/FormItem'
import AddressDetil from '../../OrderManageCreate/components/AddressDetil.vue'

const elementsCode = {
    MILEAGE: 'mileage'
}

const standardType = {
    CP001: 'CP001',
    CP002: 'CP002',
    CP003: 'CP003',
    CP004: 'CP004',
}

export default {
    components: {
        SelectAddressDialog,
        FormItemName,
        FormItemPhone,
        // FormItemAddress,
        AddressDetil,
    },
    model: {
        prop: 'endStation',
        event: 'change'
    },
    props: {
        endStation: {
            type: Object,
            required: true
        },
        startStation: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        propPrefix: {
            type: String,
            default: ''
        },
        showAddButton: {
            default: false,
            type: Boolean
        },
        showDeleteButton: {
            default: false,
            type: Boolean
        },
        standardData: {
            default: ()=>{},
            type: Object
        },
        lineorder: {
            default: false,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        },
        endStationIndex: {
            default: true,
            type: Boolean
        },
        productCode: {
            default: "",
            type: String
        },
        tenantFlag: {
            default: true,
            type: Boolean
        },
        isPretend: {
            default: false,
            type: Boolean
        },
        pretendStation: {
            default: ()=>[],
            type: Array
        },
        endStationList: {
            default: ()=>[],
            type: Array
        }
    },
    data () {
        return {
            defaultTime: moment('23:59:59', 'HH:mm:ss'),
            col: 8,
            wrapperCol: 14,
            FormValidator,
            StationTypes,
            mileageFlag: false,
            standardType,
            addressRules: [
                { required: true, message: '请选择地址', trigger: 'change' },
            ],
            defaultAddress: '',
            defaultSuffix: '',
            current:null,
        }
    },
    computed: {
        ...mapState('orderRules', ['orderRules']),
        mileage(){
            if(!this.standardData) return false 
            let flag = false
            this.standardData.elements.forEach((e) => {
                if(e.code === elementsCode.MILEAGE){
                    flag = true
                }
            })
            return flag
        }
    },
    watch:{
        endStation:{
            handler(val){
                if(val.expectTimeLeft && val.expectTimeLeft.length>0){
                    this.defaultTime=moment(val.expectTimeLeft[0]||'23:59:59','HH:mm:ss')
                }else{
                    this.defaultTime=moment('23:59:59', 'HH:mm:ss')
                }
                if(val.address){
                    this.defaultSuffix = `${val.provinceName}${val.cityName}${val.countyName}${val.address}` 
                    if(!val.name){
                        this.defaultAddress = val.address.replace(`${val.provinceName}${val.cityName}${val.countyName}`, '')
                    } else {
                        this.defaultAddress = val.name
                    }
                } else {
                    this.defaultAddress = ""
                    this.defaultSuffix = ""
                }
            },
            immediate: true
        }
    },
    methods: {
       handleFocus(){
        this.current = new Date();
      },
      handleChange(value){
          if(!value){
            this.$set(this.endStation,'expectTime',null)
            return
          }
          const {createReachTimeNum,createReachTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          // 结束时间
          const endTime =  moment(this.current).add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
         // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          if(isSameEnd){
            if(value > endTime){
              this.$set(this.endStation,'expectTime',moment(endTime))
            }else{
              this.$set(this.endStation,'expectTime',value)
            }
          }else{
            this.$set(this.endStation,'expectTime',value)
          }
      },
        disabledDate(current){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          let startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current).subtract(1, "days");
          let endTime =moment(this.current).add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          if(makeupReachTimeUnit){
            startTime = moment(startTime).subtract(1 , 'days')
          }
          if(createReachTimeUnit === TIME_UNIT.HOURS){
            endTime = moment(endTime)
          }
          return current && moment(current).startOf('days') < startTime|| moment(current).startOf('days') > endTime
        },
        disabledDateTime(){
          return {
			      disabledHours: () => this.disabledHours(this.orderRules.ORDER_CREATE_TIME_CHECK),
			      disabledMinutes: () => this.disabledMinutes(this.orderRules.ORDER_CREATE_TIME_CHECK),
		      };
        },
        disabledHours(data){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.endStation.expectTime||this.current).isSame(startTime, 'day');
          // 获取当前时间小时
          const currentHours = moment(this.current).hour();
          // 结束时间小时数计算
          const endHours = createReachTimeUnit === TIME_UNIT.HOURS? currentHours + createReachTimeNum:currentHours;
          // 开始时间小时数计算
          const startHours = makeupReachTimeUnit === TIME_UNIT.HOURS? currentHours - makeupReachTimeNum:currentHours;
          // hours数组
          const hoursList = range(0,24);
          // 结束禁用小时列表
          const endDisabledList =  hoursList.splice(hoursList.indexOf(endHours)+1,24);
          // 开始禁用小时列表
          const startDisabledList =  hoursList.splice(0,hoursList.indexOf(startHours));
          if(isSameEnd&&isSameStart){
            return [...startDisabledList,...endDisabledList]
          }
          if(isSameEnd){
            return endDisabledList
          }if(isSameStart){
            return startDisabledList
          }
          return []
        },
        disabledMinutes(data){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.endStation.expectTime||this.current).isSame(startTime, 'day');
          // 开始时间是多少小时
          const startHours= flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]).hour():moment(this.current).hour();
          // 获取当前时间小时
          const currentHours = this.endStation.expectTime? moment(this.endStation.expectTime).hour():startHours;
          // 结束时间是多少小时
          const endHours=  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit]).hour()
          if(isSameStart&&currentHours === startHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(0,minuteList.indexOf(endMinute))
            return disabled
          }if(isSameEnd&&currentHours === endHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(minuteList.indexOf(endMinute)+1,60)
            return disabled
          }
          return []
        },
        filteryugu(){
            return ((this.mileage && !this.lineorder && this.standardData && this.standardData.productCode !== standardType.CP003) || (this.standardData && this.standardData.productCode === standardType.CP001 && !this.lineorder)) && !this.isPretend
        },
        limitDecimals (value){
            const reg = /^(-)*(\d+)\.(\d\d\d).*$/;
            return `${value}`.replace(reg,'$1$2.$3');
        },
        handleSelect() {
            if(this.productCode === standardType.CP002 && this.tenantFlag){
                // let cityCode = []
                // this.startStation.forEach((e) => {
                //     if(e.cityCode){
                //     }
                // })
                if(this.isPretend){
                    let address = true
                    const cityCode = []
                    this.pretendStation.forEach((e) => {
                        if(!e.address){
                            address = false
                        } else {
                            cityCode.push(e.cityCode)
                        }
                    })
                    if(this.pretendStation.length > 0 && address){
                         this.$refs.SelectAddressDialog.show({
                            mileage: true,
                            startCityCode: cityCode,
                            isPretend: this.isPretend
                        })
                    } else {
                        this.$message.warning('请先选择起始站点')
                    }
                } else if(this.startStation.cityCode){
                    this.$refs.SelectAddressDialog.show({
                        mileage: true,
                        startCityCode: this.startStation.cityCode
                    })
                } else {
                    this.$message.warning('请先选择起始站点')
                }
                
            } else {
                this.$refs.SelectAddressDialog.show({})
            }
        },
        handleAdressFromSelectorChange({
            contacts, telPhone,stationName,
            provinceName, cityName, countyName, address,
            provinceCode, cityCode, countyCode, sourceStationId, latitude, longitude, maxReceiptPeriodTime
        }) {
            const arr = []
            // 多装多卸不予许选择相同收货站点
            if(this.isPretend){
                this.endStationList.forEach((e) => {
                    if (e.provinceCode === provinceCode && e.cityCode === cityCode && e.countyCode === countyCode && e.address === address) {
                        arr.push(e)
                    }
                })
            }
            if(arr.length <= 0){
                this.update({
                    contactPhone: telPhone,
                    contactName: contacts,
                    province: provinceName,
                    city: cityName,
                    county: countyName,
                    address,
                    provinceCode,
                    cityCode,
                    countyCode,
                    stationId: sourceStationId,
                    lat: latitude,
                    lon: longitude,
                    stationName
                })
                // 该站点是否已有收货时段,期望送达时间的结束时间
                if(maxReceiptPeriodTime) {
                    this.defaultTime = moment(`${maxReceiptPeriodTime}:00`, 'HH:mm:ss')
                } else {
                    this.defaultTime = moment('23:59:59', 'HH:mm:ss') 
                }
            } else {
                this.$message.warning('收货地信息不能重复！')
            }
        },
        handleAdressChange(address) {
            const arr = []
            // 多装多卸不予许选择相同收货站点
            if(this.isPretend){
                this.endStationList.forEach((e) => {
                    if (e.provinceCode === address.provinceCode && e.cityCode === address.cityCode && e.countyCode === address.countyCode && e.address === address.adress) {
                        arr.push(e)
                    }
                })
            }
            if(arr.length <= 0){
                this.update(address)
            } else {
                this.defaultAddress = ' '
                this.defaultSuffix = ' '
                this.$message.warning('收货地信息不能重复！')
            }
        },
        update(infos) {
            const {address, province, city, county} = infos
            this.$emit('changeDetil')
            this.$emit('change', {
                ...this.endStation,
                ...infos,
                stationFullAddress: `${province || ''}${city || ''}${county || ''}${address || ''}`,
                provinceName: province,
                cityName: city,
                countyName: county,
                address
            })
        },
        removeData(){
            const { contactName, contactPhone, expectTime, crmNumber, mileageKm, stationGoodsList, orderGoodsType} = this.endStation
            this.$emit('change', {
                stationId: '',
                provinceName: '',
                cityName: '',
                countyName: '',
                address: '',
                defaultAddress: [],
                orderGoodsType,
                contactName, contactPhone, expectTime, crmNumber, mileageKm,
                stationGoodsList
            })
            this.$emit('removePrice')
        },
        // 添加目的地
        onAdd() {
            this.$emit('add')
        },
        // 删除目的地
        onDelete() {
            this.defaultAddress = ''
            this.defaultSuffix = ''
            this.$emit('delete')
        }
    },
}
</script>

<style lang="less" scoped>
.address-choose {
    margin-bottom: 14px;
    .ant-btn {
        padding-left: 32px;
    }
}
.verActive{
    margin-top: -10px;
}
.title {
    font-size: 30px;
    font-weight: 500;
}

.subtitle-label{
    display: flex;
    margin-bottom: 10px;
    .subtitle {
        flex: 1;
        font-weight: bold;
        font-size: 16px;
    }
}
.addressIcon{
    width: 16px;
    margin-top: -2px;
}
.btnStyle{
    margin-bottom: 18px;
}
/deep/ .ant-space-item{
    margin-bottom: 0 !important;
}
/deep/ .orderNumStyle{
    max-width: 302px !important;
    width: 100%;
}
.tableBox{
    margin-bottom: 20px;
}
.deleteStyle{
    position: absolute;
    right: 30px;
    top: 24px;
    color: #F56C6C;
    &:hover{
        cursor: pointer;
    }
}
::v-deep .ant-card-bordered{
    border: none;
}
</style>